import CommonUtil from "@/utils/CommonUtil";
import moment from "moment";
export default {
  name: "ReserveForm",
  computed: {
    CommonUtil() {
      return CommonUtil;
    }
  },
  props: {
    reserveDay: {
      type: Number,
      require: false,
      default: 0
    },
    reserveTime: {
      type: Array,
      require: false,
      default: []
    },
    reserveTimeMinHour: {
      type: Number,
      require: false,
      default: -1
    },
    reserveTimeMinMinute: {
      type: Number,
      require: false,
      default: -1
    },
    reserveNowClick: {
      type: Function,
      require: false,
      default: null
    },
    reserveEnterClick: {
      type: Function,
      require: false,
      default: null
    }
  },
  data() {
    return {
      selectReserveDay: this.reserveDay,
      selectReserveTime: this.reserveTime,
      dataReserveTimeMinHour: 0,
      dataReserveTimeMinMinute: 0,
      dataReserveDay: this.reserveDay
    };
  },
  mounted() {
    this.setReserveFormTime(this.selectReserveDay);
  },
  watch: {
    reserveDay() {
      this.selectReserveDay = this.reserveDay;
    },
    reserveTime() {
      this.selectReserveTime = this.reserveTime;
    },
    selectReserveDay() {
      this.setReserveFormTime(this.selectReserveDay);
    }
  },
  methods: {
    setReserveFormTime(day) {
      let minHourMinute = CommonUtil.formatComputeDate(new Date(), 30, "minutes", "HH,mm");
      // if (this.selectReserveTime.length < 2) {
      //   this.selectReserveTime = minHourMinute;
      // }
      console.log(minHourMinute);
      if (day === 0) {
        if (minHourMinute && minHourMinute.length > 0) {
          minHourMinute = minHourMinute.split(",");
          if (this.reserveTimeMinHour === -1) {
            this.dataReserveTimeMinHour = minHourMinute[0];
          }
          if (this.reserveTimeMinMinute === -1) {
            this.dataReserveTimeMinMinute = minHourMinute[1];
          }
        }
      }
      if (day > 0) {
        if (this.reserveTimeMinHour === -1) {
          this.dataReserveTimeMinHour = 0;
        }
        if (this.reserveTimeMinMinute === -1) {
          this.dataReserveTimeMinMinute = 0;
        }
      }
      if (this.reserveTimeMinHour > -1) {
        this.dataReserveTimeMinHour = this.reserveTimeMinHour;
        console.log(this.dataReserveTimeMinHour);
      }
      if (this.reserveTimeMinMinute > -1) {
        this.dataReserveTimeMinMinute = this.reserveTimeMinMinute;
        console.log(this.dataReserveTimeMinMinute);
      }
    },
    reserveTimePickerFormatter(type, option) {
      if (type === 'hour') {
        option.text += '时';
      }
      if (type === 'minute') {
        option.text += '分';
      }
      return option;
    },
    nowButtonClick() {
      if (this.reserveNowClick) {
        this.reserveNowClick();
      }
    },
    reserveButtonClick() {
      if (this.reserveEnterClick) {
        this.reserveEnterClick(this.selectReserveDay, this.selectReserveTime, moment().add(this.selectReserveDay, "days").format("YYYY-MM-DD"));
      }
    }
  }
};